module.exports = __webpack_public_path__ + "img/photo.9124fb13.jpg";